// Shared stub for API functions that were removed during the super-admin migration.
// Re-exported from individual modules so legacy consumer code (pages/sections/hooks/store)
// still imports a real symbol — the build stays green; runtime calls throw with a
// clear "needs migration" message instead of silently 404-ing.

export const removedStub = (name) => async () => {
  const msg = `[adminpanel-dev] ${name}() is unavailable: removed in the super-admin API migration. Rebuild the UI surface that calls it.`;
  // eslint-disable-next-line no-console
  console.warn(msg);
  throw new Error(msg);
};
